import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css"; // For icons
import "./ContactusFooter.css";
const ContactFooter = () => {
  return (
    <footer className="contact-footer" id="contact-us">
      <h2 className="contact-heading">Contact Us</h2>

      <div className="contact-container">
        {/* Mobile Numbers */}
        <div className="contact-item">
          <h5>Mobile</h5>
          <p>
            <a href="tel:+919833812600" style={{ textDecoration: "none", color: "inherit" }}>
              +91 98338 12600
            </a>
          </p>

          <p>
            <a href="tel:+919833812601" style={{ textDecoration: "none", color: "inherit" }}>
              +91 98338 12601
            </a>
          </p>
        </div>

        {/* Emails */}
        <div className="contact-item">
          <h5>Email</h5>
          <p>ravish1.suryoday@gmail.com</p>
          {/* <p>info@company.com</p> */}
        </div>

        {/* Address */}
        <div className="contact-item">
          <h5>Address</h5>
          <p>A-16, Patil Bhuvan, N.S. Road, Mulund West, Mumbai - 400080</p>
          {/* <p>MG Road, Andheri East, Mumbai – 400069, India</p> */}
        </div>

        {/* Social Links */}
        {/* <div className="contact-item">
          <h5>Follow Us</h5>
          <div className="social-links">
            <a href="https://www.facebook.com/YourCompany" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="bi bi-facebook"></i>
            </a>
            <a href="https://www.instagram.com/YourCompany" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="bi bi-instagram"></i>
            </a>
            <a href="https://x.com/NASA" target="_blank" rel="noopener noreferrer" aria-label="X">
              <i className="bi bi-x" style={{ fontWeight: 700, fontSize: "1.7rem" }}></i>
            </a>

            <a href="https://www.linkedin.com/company/YourCompany" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="bi bi-linkedin"></i>
            </a>
          </div>
        </div> */}
      </div>

      <hr className="footer-divider" />
      <p className="footer-bottom">
        {" "}
        <a
          href="https://smtechno.com/"
          style={{ textDecoration: "underline", color: "inherit" }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#2563eb")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "inherit")}
        >
          © {new Date().getFullYear()} S M Techno Consultants Pvt Ltd. All Rights Reserved.
        </a>
      </p>
    </footer>
  );
};

export default ContactFooter;
